import React from "react";

const NoBeneficiary = () => (
  <svg width="220" height="148" viewBox="0 0 220 148" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="94" cy="74" r="74" fill="#B8AEE9" fillOpacity="0.13" />
    <path
      d="M50.9439 79.2325H51.2663H213.908C215.423 79.2325 216.877 79.8345 217.948 80.9059C219.02 81.9774 219.622 83.4306 219.622 84.9459V115.124C219.622 116.64 219.02 118.093 217.948 119.164C216.877 120.236 215.423 120.838 213.908 120.838H50.9439C49.4286 120.838 47.9754 120.236 46.904 119.164C45.8325 118.093 45.2306 116.64 45.2306 115.124V84.9459C45.2306 83.4306 45.8325 81.9774 46.904 80.9059C47.9754 79.8345 49.4286 79.2325 50.9439 79.2325Z"
      fill="white"
      stroke="#EBEBEB"
      strokeWidth="0.644724"
    />
    <path
      d="M128.014 90H96.6288C94.6287 90 93.0073 91.6214 93.0073 93.6214C93.0073 95.6215 94.6287 97.2429 96.6288 97.2429H128.014C130.015 97.2429 131.636 95.6215 131.636 93.6214C131.636 91.6214 130.015 90 128.014 90Z"
      fill="#9185CB"
      fillOpacity="0.38"
    />
    <path
      d="M149.743 103.691H96.6288C94.6287 103.691 93.0073 105.313 93.0073 107.313C93.0073 109.313 94.6287 110.934 96.6288 110.934H149.743C151.743 110.934 153.364 109.313 153.364 107.313C153.364 105.313 151.743 103.691 149.743 103.691Z"
      fill="#9185CB"
      fillOpacity="0.12"
    />
    <path
      d="M69.5 113.533C76.9558 113.533 83 107.489 83 100.033C83 92.5774 76.9558 86.5332 69.5 86.5332C62.0442 86.5332 56 92.5774 56 100.033C56 107.489 62.0442 113.533 69.5 113.533Z"
      fill="#141516"
    />
    <path
      d="M73.3767 96.0536L70.4622 104H68.5268L65.6124 96.0536H67.3201L69.5059 102.372L71.6804 96.0536H73.3767Z"
      fill="white"
    />
    <path
      d="M6.03571 26.3224H6.35808H169C170.515 26.3224 171.968 26.9243 173.04 27.9958C174.111 29.0672 174.713 30.5204 174.713 32.0357V62.2143C174.713 63.7296 174.111 65.1828 173.04 66.2542C171.968 67.3257 170.515 67.9276 169 67.9276H6.03571C4.52044 67.9276 3.06723 67.3257 1.99576 66.2542C0.924303 65.1828 0.322362 63.7296 0.322362 62.2143V32.0357C0.322362 30.5204 0.924303 29.0672 1.99576 27.9958C3.06723 26.9243 4.52044 26.3224 6.03571 26.3224Z"
      fill="white"
      stroke="#EBEBEB"
      strokeWidth="0.644724"
    />
    <path
      d="M83.1063 37.0898H51.7205C49.7205 37.0898 48.0991 38.7112 48.0991 40.7113C48.0991 42.7113 49.7205 44.3327 51.7205 44.3327H83.1063C85.1063 44.3327 86.7277 42.7113 86.7277 40.7113C86.7277 38.7112 85.1063 37.0898 83.1063 37.0898Z"
      fill="#9185CB"
      fillOpacity="0.38"
    />
    <path
      d="M104.835 50.7812H51.7205C49.7205 50.7812 48.0991 52.4026 48.0991 54.4027C48.0991 56.4027 49.7205 58.0241 51.7205 58.0241H104.835C106.835 58.0241 108.456 56.4027 108.456 54.4027C108.456 52.4026 106.835 50.7812 104.835 50.7812Z"
      fill="#9185CB"
      fillOpacity="0.12"
    />
    <path
      d="M24.5918 60.623C32.0476 60.623 38.0918 54.5789 38.0918 47.123C38.0918 39.6672 32.0476 33.623 24.5918 33.623C17.136 33.623 11.0918 39.6672 11.0918 47.123C11.0918 54.5789 17.136 60.623 24.5918 60.623Z"
      fill="#141516"
    />
    <path d="M24.3584 49.8262H26.9768V51.0898H22.7645V43.1434H24.3584V49.8262Z" fill="white" />
  </svg>
);

export default React.memo(NoBeneficiary);
